import React, { FC } from 'react'

import Component from './'
import { Blok } from '@app/typings/blok'
import { useCloseOverlaysOnRouteChange } from '@app/hooks/use-close-overlays-on-route-change'

type Props = {
  body: Blok[]
}

export const Page: FC<Props> = (props) => {
  useCloseOverlaysOnRouteChange()

  return (
    <div>
      {props.body &&
        props.body.map((content) => (
          <Component key={content._uid} content={content} />
        ))}
    </div>
  )
}
